import React from 'react'; // eslint-disable-line
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Template from '../../components/templates/Template';
import _actions from '../../actions';
import constants from '../../constants';

class Templates extends React.Component {
    constructor(props) {
        super(props);

        this.setTemplate = this.setTemplate.bind(this);
    }

    componentDidMount() {
        this.props.actions.getProjectVersion(this.props.match.params.projectId);
        this.props.actions.getTemplates();
        document.body.classList.add('templates-view');
    }

    componentDidUpdate() {
        if (this.props.versions.select.updatedNew
            && this.props.versions.data.themeId > 0
            && this.props.templates.data.length > 0) {
            this.props.history.push(`/projects/${this.props.versions.select.projectId}/general-info`);
        }
    }

    componentWillUnmount() {
        document.body.classList.remove('templates-view');
    }

    setTemplate(id) {
        const version = this.props.versions.data;
        const theme = this.props.templates.data.find((n) => { return n.Id === id; });
        version.themeId = id;
        version.baseColorTheme = constants.ColorBaseTheme.find((n) => { return n.Name === 'Light'; }).Id;

        version.accentColor = theme.LightColors.DefaultAccentColor;
        version.actionColor = theme.LightColors.DefaultActionColor;
        version.primaryText = theme.LightColors.DefaultPrimaryTextColor;
        version.secondaryText = theme.LightColors.DefaultSecondaryTextColor;

        this.props.actions.updateProjectVersion(this.props.match.params.projectId, version);
    }

    render() {
        const head = (
            <div className="app-intro__intro">
                <h1 className="app-intro">Choose a Template</h1>
            </div>
        );
        const view = (
            <div className="app-intro-wrapper-inside">
                {false ? head : ''}
                <div className="theme-list">
                    {this.props.templates.data.map((template) => {
                        return (
                            <Template
                                key={template.id}
                                id={template.id}
                                name={template.name}
                                onClick={this.setTemplate}
                                description={template.description}
                                solo={this.props.templates.data.length === 1}
                            />
                        );
                    })}
                </div>
            </div>
        );
        if (this.props.versions.updatedNew) {
            this.props.history.push(`/projects/${this.props.versions.select.projectId}/general-info`);
        }
        return view;
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        ...state,
        ...ownProps,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        actions: bindActionCreators(_actions, dispatch),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Templates);
